import React, { ReactElement } from "react";
import { ThemeProvider } from "styled-components";

import BlockQuote from "components/BlockQuote";
import Icon from "components/Icon/Icon";
import Section from "components/Section";
import useIsInEditMode from "hooks/useIsInEditMode";
import { addEditAttributes } from "utils/episerver";

import {
    Container,
    Heading,
    Introduction,
    BlockQuotes,
    ReadMoreContainer,
    Link,
    Header,
} from "./BlockQuoteList.styled";
import BlockQuoteListProps from "./BlockQuoteListProps";

const BlockQuoteList = ({
    identifier,
    theme,
    heading,
    introduction,
    link,
    quotes,
    anchorName,
}: BlockQuoteListProps): ReactElement => {
    const isInEditMode = useIsInEditMode();

    return (
        <Section id={anchorName} theme={theme} alignItems="center">
            <ThemeProvider
                theme={{
                    theme: theme,
                }}
            >
                <Container key={identifier || `BlockQuoteListContent`}>
                    {(isInEditMode || heading) && (
                        <Header>
                            <Heading
                                {...addEditAttributes("Heading")}
                                dangerouslySetInnerHTML={{
                                    __html: heading || "",
                                }}
                            />
                            {(isInEditMode || introduction) && (
                                <Introduction
                                    {...addEditAttributes("Introduction")}
                                    dangerouslySetInnerHTML={{
                                        __html: introduction || "",
                                    }}
                                />
                            )}
                        </Header>
                    )}
                    <BlockQuotes $count={quotes ? quotes.length : 0}>
                        {quotes?.map((quote, index) => (
                            <BlockQuote
                                key={`BlockQuote${index}`}
                                id={
                                    anchorName
                                        ? `${anchorName}-${index}`
                                        : identifier
                                          ? `${identifier}-${index}`
                                          : ""
                                }
                                {...quote}
                            />
                        ))}
                    </BlockQuotes>
                    {link?.linkText && (
                        <ReadMoreContainer>
                            <Link linkRef={link} hoverSpan={true}>
                                <span>{link.linkText}</span>
                                <Icon
                                    icon="longArrowRight28"
                                    aria-hidden="true"
                                />
                            </Link>
                        </ReadMoreContainer>
                    )}
                </Container>
            </ThemeProvider>
        </Section>
    );
};

export default React.memo(BlockQuoteList);
